<nav class="d-none d-sm-block page-navbar navbar navbar-expand-md navbar-dark">
  <div class="container">
    <div class="no-collapse">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active" *ngFor="let menu of topMenus">
          <a class="nav-link" [routerLink]="menu.slug">
            <span (click)="onTopMenuClick($event, menu)">{{ menu.name }}</span>
          </a>
          <div *ngIf="hasChildMenus(menu)" class="megamenu" [ngClass]="{ 'megamenuactive': menu.isActive }">
            <div class="container">
              <div class="row">
                <div class="col col-xl-2 col-lg-3 col-md-3 col-sm-12" *ngFor="let childCode of menu.children">
                  <app-mega-menu-block [menuItems]="menuItems" [code]="childCode" (onItemClick)="itemClick()">
                  </app-mega-menu-block>
                </div>
              </div>
            </div>
            <div class="close-megamenu text-center">
              <a (click)="closeMegaMenu()">
                <i class="fa fa-angle-up"></i>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
